import { PageBuilderPageModel } from "@de-trustleap/shared-models";
import { createSectionElement } from "./createSectionElement";
import { Logger } from "../utils/logger";
import { isPreviewMode } from "../utils/previewUtils";
import { renderPreviewBanner } from "../utils/renderPreviewBanner";

export function renderPage(pagemodel: PageBuilderPageModel) {

    if (isPreviewMode()) {
        renderPreviewBanner();
    }

    const sections = pagemodel.sections ?? [];

    if (sections.length === 0) {
        Logger.error("❌ Keine Sections im PageModel gefunden.");
        return;
    }

    const container = createPageContainer();

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const index = Number((entry.target as HTMLElement).dataset.index);
            const section = sections[index];

            try {
                const sectionElement = createSectionElement(section);
                if (sectionElement) {
                    entry.target.replaceWith(sectionElement);
                    Logger.debug(`✅ Section ${index} erfolgreich geladen.`);
                } else {
                    Logger.warn(`⚠️ Section ${index} konnte nicht erstellt werden.`);
                }
            } catch (err) {
                Logger.error(`❌ Fehler beim Rendern von Section ${index}`, err);
            }

            observer.unobserve(entry.target);
        });
    }, {
        rootMargin: "200px"
    });

    sections.forEach((section, index) => {
        const placeholder = createLazyPlaceholder(index);
        container.appendChild(placeholder);
        observer.observe(placeholder);
    });

    Logger.info("✅ Page Rendering gestartet.");
}

function createPageContainer(): HTMLElement {
    const container = document.createElement("div");
    document.body.appendChild(container);
    return container;
}

function createLazyPlaceholder(index: number): HTMLElement {
    const placeholder = document.createElement("div");
    placeholder.classList.add("lazy-section");
    placeholder.style.minHeight = "300px";
    placeholder.dataset.index = index.toString();
    return placeholder;
}
